"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _AVNURAH2cjs = require('../__chunks/AVNURAH2.cjs');


var _7XPYSHN7cjs = require('../__chunks/7XPYSHN7.cjs');
require('../__chunks/F7D3HWZN.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/select/select-separator.tsx
var TagName = "hr";
var useSelectSeparator = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectSeparator2({ store, ...props }) {
    const context = _AVNURAH2cjs.useSelectContext.call(void 0, );
    store = store || context;
    props = _7XPYSHN7cjs.useCompositeSeparator.call(void 0, { store, ...props });
    return props;
  }
);
var SelectSeparator = _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectSeparator2(props) {
  const htmlProps = useSelectSeparator(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.SelectSeparator = SelectSeparator; exports.useSelectSeparator = useSelectSeparator;
